import {
  AUTH_DISCARD_USER,
  AUTH_SET_USER,
  CHANGE_SHOP,
  IMPERSONATE_USER,
  RESET_SHOP,
  REVERSE_USER,
  SET_BRAND,
} from '../auth/constants';
import { persistentKVStore } from '../../modules/infra/persistence';

const sessionMiddleware = () => next => (action) => {
  next(action);
  switch (action.type) {
    case AUTH_DISCARD_USER:
      persistentKVStore.removeItem('token');
      persistentKVStore.removeItem('adminToken');
      persistentKVStore.removeItem('shop');
      persistentKVStore.removeItem('activeType');
      break;
    case AUTH_SET_USER:
      persistentKVStore.setItem('token', action.token);
      break;
    case CHANGE_SHOP:
      persistentKVStore.setItem('shop', action.shop.id);
      persistentKVStore.setItem('activeType', 'shop');
      break;
    case SET_BRAND:
      persistentKVStore.setItem('activeType', 'brand');
      break;
    case RESET_SHOP:
      persistentKVStore.removeItem('shop');
      break;
    case REVERSE_USER:
      persistentKVStore.removeItem('shop');
      persistentKVStore.setItem('token', persistentKVStore.getItem('adminToken'));
      persistentKVStore.removeItem('adminToken');
      break;
    case IMPERSONATE_USER:
      persistentKVStore.setItem('adminToken', persistentKVStore.getItem('token'));
      persistentKVStore.setItem('token', action.user.token);
      break;
  }
};

export default sessionMiddleware;
